/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './audit.scss';
import './audit.tpl.html';

angular
  .module('log.audit', ['sbsf.enums'])
  /**
   * Controller for the log.audit template.
   */
  .controller('AuditLogCtrl', [
    '$scope',
    '$filter',
    '$window',
    '$rootScope',
    'pagingUtils',
    'AuditViewFactory',
    'httpActivities',
    'UserAgentFactory',
    'AUDIT_DATA_TYPES',
    'ACTIVITY_VIEWS',
    'ALERT_EVENTS',
    'latestBackup',
    'AUDIT_EVENT_TYPE',
    function (
      $scope,
      $filter,
      $window,
      $rootScope,
      pagingUtils,
      AuditViewFactory,
      httpActivities,
      UserAgentFactory,
      AUDIT_DATA_TYPES,
      ACTIVITY_VIEWS,
      ALERT_EVENTS,
      latestBackup,
      AUDIT_EVENT_TYPE
    ) {
      const i18n = $filter('i18n');

      $scope.getTooltipTemplateId = getTooltipTemplateId;

      $scope.auditEvents = pagingUtils.pagingInfo.audit.items;
      $scope.auditHistoryCsvTooltip = i18n('AUDIT_HISTORY_CSV_TOOLTIP');
      $scope.auditHistoryDownloadInProgress = $rootScope.auditHistoryDownloadInProgress;

      $scope.headerValues = {
        date: 'date',
        username: 'username',
        type: 'type'
      };
      $scope.reverse = true;
      $scope.showAuditLogMask = false;

      $scope.totalItems = pagingUtils.pagingInfo.audit.totalItems;
      $scope.maxSize = 0;
      $scope.itemsPerPage = pagingUtils.pagingInfo.audit.itemsPerPage;
      $scope.totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);

      // Paging params
      $scope.pagingParam = {};
      $scope.pagingParam.currentPage = 1;
      $scope.pagingParam.sortBy = $scope.headerValues.date;
      $scope.pagingParam.ascending = !$scope.reverse;

      // Need to keep track of current page just in case we get bad input and need to reset.
      $scope.currentPage = 1;

      /**
       * Utility to pull in audit event data and populate the audit data in the Paging service.
       */
      $scope.updateAuditEvents = function () {
        $scope.showAuditLogMask = true;
        pagingUtils.getAuditEvents().then(function () {
          $scope.totalItems = pagingUtils.pagingInfo.audit.totalItems;
          $scope.auditEvents = pagingUtils.pagingInfo.audit.items;
          $scope.totalPages = pagingUtils.pagingInfo.audit.totalPages;
          $scope.showAuditLogMask = false;
        });
      };

      $scope.$on('updateAuditEvent', function () {
        $scope.updateAuditEvents();
      });

      /**
       * Utility to update the current page selected and fetch audit events.
       *
       * @param {Number} pageNo - The page number to update the current page.
       * @returns {promise} A promise that when resolved will include an audit event object.
       */
      $scope.setPage = function (pageNo) {
        var page = pagingUtils.getCurrentPage(pageNo, $scope.totalPages) || $scope.currentPage;
        if (page === $scope.currentPage) {
          //if page number didn't change then ignore setPage request
          $scope.pagingParam.currentPage = page;
          return;
        }
        if (page) {
          $scope.pagingParam.currentPage = page;
          $scope.currentPage = page;
        }
        pagingUtils.updateAudit($scope.pagingParam);
        $scope.showAuditLogMask = true;
        return pagingUtils.getAuditEvents().then(function () {
          $scope.totalItems = pagingUtils.pagingInfo.audit.totalItems;
          $scope.auditEvents = pagingUtils.pagingInfo.audit.items;
          $scope.totalPages = pagingUtils.pagingInfo.audit.totalPages;
          $scope.showAuditLogMask = false;
        });
      };

      /**
       * Debounced set page function
       */
      $scope.setPageDebounced = _.debounce($scope.setPage, 500);

      /**
       * Returns the event type string
       * for the audit event.
       *
       * @param {object} audit - The audit event object.
       * @returns {string} A formatted event string.
       */
      $scope.getEventType = function (audit) {
        var data = audit.data,
          dataType = AUDIT_DATA_TYPES[audit.type] || '',
          val;
        switch (dataType) {
          case 'boolean':
            val = data.newValue;
            break;
          case 'string':
            val = data.newValue;
            break;
          case 'date':
            val = moment(data.newValue.end).format('MMMM D, YYYY');
            break;
          case 'array':
            val = _.values(data.newValue);
            break;
          case 'usekmschange':
            return AuditViewFactory.getKmsEnabledDisabled(audit);
          case 'serviceaccountchange':
            return AuditViewFactory.getNewServiceAccountUserName(audit);
          case 'function':
            return AuditViewFactory.getAuditViewType(audit.type, data);
          case AUDIT_DATA_TYPES.ALERT_RULE_ADDED:
            return i18n('ALERT_RULE_ADDED');
          case AUDIT_DATA_TYPES.ALERT_RULE_CHANGED:
            return i18n('ALERT_RULE_CHANGED');
          case AUDIT_DATA_TYPES.ALERT_RULE_DELETED:
            return i18n('ALERT_RULE_DELETED');
          case AUDIT_DATA_TYPES.API_LIMIT_CHANGED:
          case AUDIT_DATA_TYPES.BULK_API_LIMIT_CHANGED:
            val = !_.isUndefined(data) && !_.isNull(data) ? $filter('number')(data.newValue) : null;
            break;
          case AUDIT_DATA_TYPES.USER_PERMISSIONS_CHANGED:
            val = !_.isUndefined(data) && !_.isNull(data) ? data.targetUserName : null;
            break;
          default:
            val =
              !_.isUndefined(data) && !_.isNull(data) && !data.actor
                ? $filter('number')(data.newValue)
                : audit.username;
            break;
        }
        // in the array case we end up with a [][] so use flatten to make it []
        return i18n(audit.type, _.flatten([val]));
      };

      /**
       * Returns the DOM id of the tooltip template for an audit event.
       *
       * @param {object} audit - the audit event to be checked
       * @returns {string} the DOM id if the tooltip template for the event, if it has one.
       */
      function getTooltipTemplateId(audit) {
        switch (audit.type) {
          case AUDIT_EVENT_TYPE.ALERT_RULE_ADDED:
            return 'alert-rule-added';

          case AUDIT_EVENT_TYPE.ALERT_RULE_CHANGED:
            return 'alert-rule-changed';

          case AUDIT_EVENT_TYPE.ALERT_RULE_DELETED:
            return 'alert-rule-deleted';

          default:
            break;
        }
      }

      /**
       * Returned the formatted date string from an
       * audit object.
       *
       * @param {string} auditDate - A string date.
       * @returns {string} A formatted date string.
       */
      $scope.getDate = function (auditDate) {
        return moment(auditDate).format('ddd,  MMM D[,] YYYY');
      };

      /**
       * Returned the formatted time from an
       * audit object.
       *
       * @param {string} actionDate - A string date.
       * @returns {string} A formatted time string.
       */
      $scope.getTime = function (auditDate) {
        return moment(auditDate).format('hh:mm a');
      };

      $scope.getUsernameWithEmail = function (data) {
        if (!data) {
          return '';
        }
        if (data.displayName && data.loginType && data.loginType.scope === 'EXTERNAL') {
          return `${data.displayName} (${data.email})`;
        } else if (data.email) {
          return `${data.username} (${data.email})`;
        }
        return data.username;
      };

      /**
       * Returns boolean whether to show up or down arrow for header.
       * @param header - The header value.
       * @returns {string} The class to use.
       */
      $scope.isSelectedHeader = function (header) {
        var headerClass = '';
        if ($scope.pagingParam.sortBy === header) {
          if ($scope.reverse) {
            headerClass = 'sbsf-log-header-desc sca-icon-down-black';
          } else {
            headerClass = 'sbsf-log-header-asc sca-icon-down-black';
          }
        }
        return headerClass;
      };

      /**
       * Sets the sort parameter to the header selected.
       * @param {String} header - The header value and property to sort by.
       */
      $scope.selectHeader = function (header) {
        $scope.showAuditLogMask = true;
        $scope.reverse = !$scope.reverse;
        $scope.pagingParam.sortBy = header;
        $scope.pagingParam.ascending = !$scope.reverse;
        pagingUtils.updateAudit($scope.pagingParam);
        return pagingUtils.getAuditEvents().then(function () {
          $scope.auditEvents = pagingUtils.pagingInfo.audit.items;
          $scope.totalItems = pagingUtils.pagingInfo.audit.totalItems;
          $scope.totalPages = pagingUtils.pagingInfo.audit.totalPages;
          $scope.showAuditLogMask = false;
        });
      };

      /**
       * Download a CSV of all of the audit history.
       */
      $scope.downloadAuditHistoryCsv = function () {
        if (!$scope.auditHistoryDownloadInProgress) {
          $scope.auditHistoryDownloadInProgress = true;
          $rootScope.auditHistoryDownloadInProgress = $scope.auditHistoryDownloadInProgress;

          $rootScope.$emit(ALERT_EVENTS.SUCCESS.eventName, i18n('DOWNLOAD_START'), true, null);

          httpActivities.downloadAuditHistoryCsv().then(
            function (result) {
              const fileName = `Settings-History-Log-${moment().format('MMM-D-YYYY')}.csv`;
              const browser = UserAgentFactory.detectBrowser();
              let blob;

              //If it's IE do some black magic and use custom IE specific methods (MsSaveBlob) to save this file.
              if (browser && browser.indexOf('IE') > -1) {
                if (window.navigator.msSaveOrOpenBlob) {
                  blob = new Blob([decodeURIComponent(encodeURI(result))], {
                    type: 'text/csv;charset=utf-8;'
                  });
                  navigator.msSaveBlob(blob, fileName);
                }
              } else {
                const link = document.createElement('a');
                link.setAttribute('download', fileName);
                // convert to data URI
                link.href = 'data:text/csv;charset=utf8,' + encodeURI(result);
                document.body.appendChild(link);
                link.click();
                link.remove();
              }

              $scope.auditHistoryDownloadInProgress = false;
              $rootScope.auditHistoryDownloadInProgress = $scope.auditHistoryDownloadInProgress;
              $rootScope.$emit(ALERT_EVENTS.CLOSE.eventName);
            },
            function () {
              $scope.auditHistoryDownloadInProgress = false;
              $rootScope.auditHistoryDownloadInProgress = $scope.auditHistoryDownloadInProgress;
              $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, i18n('DOWNLOAD_ERROR'), false, null);
            }
          );
        }
      };

      // If the latestBackup is empty, there are no backups and we want to default to audit tab
      if (_.isEmpty(latestBackup)) {
        $scope.showView(ACTIVITY_VIEWS.AUDIT);
      }
    }
  ]);
